export const virtualTourPluginConfig = {
  positionMode: "manual",
  renderMode: "3d",
  preload: true,

  arrowStyle: {
    color: "#00BFFF",
    hoverColor: "#FFFFFF",
    outlineColor: "#000000",
    scale: [0.5, 2]
  },

  markerStyle: {
    size: { width: 50, height: 50 },
    anchor: "bottom center",
    tooltip: {
      content: "Ir para o próximo ponto",
      position: "top"
    }
  }
};
